module.exports = __webpack_public_path__ + "img/bodycheck2.db95bc69.jpg";